import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NotifierService } from '../../ui';
import { FormControl, Validators } from '@angular/forms';
import { DLLedgerTemplate, DLSettings } from './model';
import { DLSettingsService } from './settings.service';

@Component({
  templateUrl: './settings.component.html',
})
export class DLSettingsComponent implements OnInit {

  title: string

  name: FormControl

  settings: DLSettings
  template: DLLedgerTemplate

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private settingsService: DLSettingsService,
    private notifier: NotifierService,
  ) { }

  initForm() {
    this.template = {
      name: '',
      signed: true,
    };

    // ledgerName
    this.name = new FormControl(null, [
      Validators.required
    ]);

    this.name.valueChanges.subscribe((value) => {
      this.template.name = value;
    });
  }

  ngOnInit() {
    // Get the settings
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.title = data.title;

      this.settingsService.settings().subscribe((result) => {
        this.settings = result;

        this.initForm();

        this.notifier.endProgress();
      }, () => {
        this.notifier.endProgress();
      });
    }, () => {
      this.notifier.endProgress();
    });
  }

  nameKeyup(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.addLedgerTemplate();
    }
  }

  addLedgerTemplate() {
    if (!this.name || !this.name.valid || this.template.name.trim().length == 0) {
      return;
    }

    this.settings.ledgerTemplates.push({
      name: this.template.name,
      signed: this.template.signed,
    });

    this.updateSettings();
  }

  deleteLedgerTemplate(index: number) {
    this.settings.ledgerTemplates.splice(index, 1);

    this.updateSettings();
  }

  updateSettings() {
    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.settingsService
    .updateSettings(this.settings).pipe(
      finalize(onComplete))
    .subscribe((result) => {
      this.settings = result;

      this.notifier.success('Liste des catégories de registres modifiée avec succès');

      this.name.setValue('');
      this.template.signed = true;
    });
  }

  cancel() {
    this.router.navigate(['documents-ledger']);
  }
}
